import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';
import { StatusBadgeStatus } from './StatusBadge';

export const StatusBadgeContainer = styled.div<{
  $status: StatusBadgeStatus;
}>`
  display: inline-flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 14px;
  width: auto;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  ${(props) => {
    switch (props.$status) {
      case 'COMPLETED':
        return `
          background: ${props.theme.atlas.semantic.color.status.success.default};
            color: ${props.theme.atlas.semantic.color.status.success.textDefault};
        `;
      case 'PARTIAL_SUCCESS':
        return `
            background: ${props.theme.atlas.semantic.color.status.warning.default};
            color: ${props.theme.atlas.semantic.color.type.default};
        `;
      case 'FAILED':
        return `
            background: ${props.theme.atlas.semantic.color.status.error.default};
            color: ${props.theme.atlas.semantic.color.action.primary.onPrimary};
        `;
    }
  }}
`;

export const StatusBadgeIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StatusBadgeLabel = styled.span`
  white-space: nowrap;
`;
